import React, { useState, useEffect } from 'react'
import './patientdetails.css'
import { clearInterbranchData, fetchPatientBasicDetails, fetchPatientDetails, fetchPatientPrimaryDetails, registerPatient, Store_formData } from "../../../../actions/InterBranchCoordinatorAction"
import { useSelector, useDispatch } from "react-redux";
import { Form, Input, Radio } from 'antd';

import arrowRight from '../../../../assets/InterBranch/PNGIcons/arrow-right.png'
import checkImage from '../../../../assets/InterBranch/PNGIcons/check.png'
import CustomPhoneInput from '../../../CustomPhoneInput/CustomPhoneInput';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { PulseLoader } from 'react-spinners';
import CustomPhoneInputV2 from '../../../CustomPhoneInputV2/CustomPhoneInputV2';
import { INTERBRANCH_CLEAR_TEMP_APPOINTMENT_FORM, INTERBRANCH_MODAL_UPDATE, INTERBRANCH_UPDATE_TEMP_APPOINTMENT_FORM } from '../../../../actions/type';
import { checkUser } from '../../../../actions/SignupAction';
import { SimpleCloseIconRed } from '../../../../assets/Logos/Icons';
import { ConsoleSqlOutlined } from '@ant-design/icons';

function PatientDetail({ isSchedule }) {


    let dispatch = useDispatch();
    let history = useHistory()
    let { path, url } = useRouteMatch();

    let clinicId = useSelector((state) => state?.login?.user?.clinicId);
    let reduxData = useSelector(state => state);
    //Destructuring data from redux........................................
    let { patientName, patientNumber, patientHospitalId, gender, aadhaarNumber, emergencyContactName, emergencyContactNumber, emailID, } = useSelector(state => state?.interBranchCoordinator?.appointment_form)

    let appointment_form = useSelector(state => state?.interBranchCoordinator?.appointment_form)
    let temp_appointment_form = useSelector(state => state?.interBranchCoordinator?.temp_appointment_form)

    const [form] = Form.useForm();

    let [isAadhaar, setAadhar] = useState(false);

    let [aadharNumber, setAadhaarNumber] = useState(null);
    let [startVerify, setStartVerify] = useState(false);

    let [mobile, setMobile] = useState(reduxData?.interBranchCoordinator?.appointment_form?.patientNumber);
    let [isMobileVerified, setMobileVerified] = useState(false)
    let [isMobileChanged, setMobileChanged] = useState(false)

    let [mobileWithDiallCode, setMobileWithDialCode] = useState(patientNumber);
    let [isFilled, setFilled] = useState(false);

    let [emergencyContactNumberWithDialcode, setEmergencyContactNumber] = useState(emergencyContactNumber)

    let [isSaving, setSaving] = useState(false)

    let [mobileOtp, setMobileOtp] = useState(null)

    const [actualOTP, setActualOTP] = useState(null);



    useEffect(() => {

        if (patientName || patientNumber || gender) {
            setFilled(true)
        }

        loadDefaultValues()


    }, [])


    useEffect(() => {

        form.setFieldsValue({
            aadhaarNumber,
            emergencyContactName,
            emergencyContactNumber: emergencyContactNumber?.number,
            patientHospitalId,
            patientName,
            patientNumber: patientNumber?.number,
            gender,
            emailID
        })

    }, [appointment_form])



    //Functions............................................................


    let handleAadhaarOnChange = (e) => {

        handleChangeFormItem({ key: "aadhaarNumber", value: e.target.value })

        setAadhaarNumber(e.target.value);
        setStartVerify(false);
        setAadhar(false);
        form.setFieldsValue({ aadhaarNumber: e.target.value.replace(/\D/g, "") })
    }


    const checkOTP = (mobNumber) => {
        // console.log("Mobile Number: ",mobNumber)

        try {
            dispatch(
                checkUser({
                    searchtype: "Mobile",
                    searchKey: mobNumber
                })
            )
                .then((res) => {
                    console.log("Info:", res)
                    if (res?.info) {
                        let resValue = res?.info;
                        //setActualOTP(resValue)
                        setActualOTP("78901");

                    }
                })
        } catch (error) {
            //console.log("Error in OTP generating API", error);
        }
    }

    const onFinish = (values) => {
        // console.log('Success:', values);

        if (emergencyContactNumberWithDialcode.number == mobileWithDiallCode.number) {

            dispatch({
                type: INTERBRANCH_MODAL_UPDATE,
                payload: { modalName: "commomAlertModal", isVisible: true, data: "Please enter different emergency contact number." }
            })
        }
        else {

            let submissionData = {
                aadhaarNumber: values.aadhaarNumber,
                emergencyContactName: values.emergencyContactName,
                patientHospitalId: values.patientHospitalId,
                patientName: values.patientName,
                gender: values.gender,
                emailID: values.emailID,
                isPatientNumberVerified: isMobileVerified,

                emergencyContactNumber: temp_appointment_form?.emergencyContactNumber,
                patientNumber: temp_appointment_form?.patientNumber,
            }

            setSaving(true)
            dispatch(
                Store_formData({
                    ...reduxData.interBranchCoordinator.appointment_form,
                    ...submissionData,
                })
            ).then((res) => {

                dispatch(registerPatient(clinicId, submissionData))
                    .then((res) => {
                        console.log(res)
                        setSaving(false)
                        if (res.data.info != 'Failed') {
                            localStorage.setItem("PatientId", res.data.info)
                        }

                        history.push(`/dashboard/${url.includes("bookandconsult") ? "bookandconsult" : "scheduleappointment"}/choosedoctor`)

                    });

            });

        }


    };


    const onFinishFailed = (errorInfo) => {
        //console.log('Failed:', errorInfo);
    };

    const onValuesChange = (values, allValues) => {


        dispatch({
            type: INTERBRANCH_UPDATE_TEMP_APPOINTMENT_FORM,
            payload: {
                ...values,
                patientNumber: mobileWithDiallCode,
                emergencyContactNumber: emergencyContactNumberWithDialcode
            }
        })

        if (allValues.patientNumber && allValues.patientNumber.length >= 6 && allValues.patientName && isMobileVerified && allValues.gender) {

            setFilled(true)
        }
        else {
            setFilled(false)
        }



    }

    let validateLettersOnly = (event) => {

        // //console.log( event.which );

        if (event.which === 46 || event.which === 8 || event.which === 32) {

        }

        else if ((event.which < 65 || event.which > 90)) {
            event.preventDefault();
        }


    }

    let validateEmailId = (e) => {

        // if (e.target.value.includes(".") && e.key == ".") {
        //     e.preventDefault()
        // }

        // if (e.target.value.includes("@") && e.key == "@") {
        //     e.preventDefault()
        // }
        if (e.key.match(new RegExp("/^[a-zA-Z0-9]+@+[a-zA-Z0-9]+.+[A-z]/"))) {
        }
        else {
            e.preventDefault();

        }

    }


    let renderPhoneValidation = () => {




    }


    let startMobileNumberVerification = (mobile) => {
        // console.log("Mobile: ",mobile)

        checkOTP("%2B" + mobile);
        setMobileChanged(false)
        setStartVerify(true)

    }

    let verifyMobileNumber = async (mobile) => {


        form.validateFields(["patientNumberOTP"])
            .then((res) => {
                if (res && res.patientNumberOTP) {
                    if (mobileOtp === actualOTP) {
                        setStartVerify(false)
                        setMobileVerified(true);
                        form.setFieldsValue({ patientNumberOTP: null })
                        try {
                            dispatch(
                                fetchPatientPrimaryDetails({
                                    searchtype: "Mobile",
                                    searchKey: "%2B" + mobile,
                                    appointment_form: temp_appointment_form
                                })
                            )
                                .then((res) => {
                                    console.log("Info:", res)
                                    console.log("Form:", temp_appointment_form)


                                    // form.resetFields(["emergencyContactNumber", "emergencyContactName", "aadhaarNumber", "patientHospitalId", "emailID"]); 

                                    form.setFieldsValue({
                                        patientName: res?.fullname,
                                        patientHospitalId: res?.hospitalid,
                                        emailID:res?.emailID,
                                        emergencyContactName:res?.emergencyname,
                                        // emergencyContactNumber:{
                                        //     number: res?.emergencynumber?.split(' ')[1],
                                        //     countryCode: res?.emergencynumber?.split(' ')[0]
                                        // },
                                        aadhaarNumber:res?.aadharnumber,
                                        gender:res?.gender
                                    })

                                })
                        } catch (error) {
                            console.log("Error in fetching patient's primary details API", error);
                        }

                    } else {

                        /*form.setFields([
                            {
                                name: "patientNumberOTP",
                                errors: ['Invalid OTP !'],
                            }
                        ]); */
                        setMobileVerified(true)
                    }

                }
            })


    }

    let handleChangeFormItem = ({ key, value }) => {


    }

    function allowOnlyNumericsOrDigits(e) {
        !["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "Backspace"].includes(e.key) && e.preventDefault()
    }


    let isreadyToSubmit = () => {

        let formNumber = form.getFieldValue("patientNumber")
        let formName = form.getFieldValue("patientName")
        let formGender = form.getFieldValue("gender")
        // console.log("formName:",formName,"formGender:",formGender)
        // console.log("isMobileVerified:",isMobileVerified,"formNumber:",formNumber,"patientName:",patientName,"gender",gender)
        if (isMobileVerified && formNumber && formNumber.length >= 6 && (patientName || formName) && (gender || formGender)) {
            return true
        }
        else {
            return false
        }

    }


    const loadDefaultValues = () => {

        setMobileVerified(appointment_form?.isPatientNumberVerified)
        setMobileChanged(false)


    }


    const handlePhoneNumberOnChange = ({ number, value, data, event }) => {


        setMobileOtp("")
        setFilled(false)
        setMobileWithDialCode(
            {
                dialCOde: data.dialCode,
                number: value?.slice(data.dialCode.length).trim(),
                countryCode: data.countryCode,
                numberWithCode: value

            })


        if (data?.number.trim().length > 0) {
            setMobile(value);
        }
        else {
            setMobile(null);
        }

        if ((patientNumber?.number) && (patientNumber?.number == value?.slice(data.dialCode.length))) {
            setMobileChanged(false)
        }
        else {
            setMobileChanged(true)
            setMobileVerified(false)
            setStartVerify(false)
        }

    }

    const handlePhoneNumberOnBlur = ({ value, data, event }) => {

        handleChangeFormItem({
            key: "patientNumber",
            value:
            {
                dialCOde: data.dialCode,
                number: value?.slice(data.dialCode.length),
                countryCode: data.countryCode,
                numberWithCode: value

            }
        })

    }



    return (
        <div className='patient-details-container'>

            <div className="tittle">Patient Profile

                <div className="details-item mandatory">

                    <div className="caption-mandatory"> <span className="red">*</span>  Mandatory</div>

                </div>
            </div>



            <Form
                form={form}
                name="basic"
                labelCol={{
                    span: 8,
                }}
                wrapperCol={{
                    span: 16,
                }}
                initialValues={{
                    remember: true,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                onValuesChange={onValuesChange}
                autoComplete="off"
            >
                <div className="details-item mandatory contact-number">

                    <div className="caption">Patient Mobile Number <div className="red">*</div></div>
                    <div className="input-item ">

                        <Form.Item

                            name="patientNumber"
                            // initialValue={patientNumber?.number}
                            rules={[
                                { min: 6, message: 'The mobile number should be minimum 6 digits' },
                                { max: 12, message: 'The mobile number should be maximum 12 digits' },
                                {
                                    required: true,
                                    message: "*Patient mobile number can't be empty",
                                }

                            ]}

                        >

                            <CustomPhoneInputV2
                                // key={patientNumber?.number}
                                defaultCountryCode={patientNumber?.countryCode}
                                defaultvalue={patientNumber?.number}
                                name="patientNumber"
                                onBlur={(value, data, event) => { handlePhoneNumberOnBlur({ value, data, event }) }}
                                onChange={(number, value, data, event) => { handlePhoneNumberOnChange({ number, value, data, event }) }}
                                placeholder={"Enter Mobile Number"}
                            />


                            {/* <Input style={{ width: "100%" }} className='input' placeholder="" /> */}
                        </Form.Item>

                        <div className="verify-aadhaar">


                            {
                                ((mobile && !isMobileVerified && !startVerify) || isMobileChanged && mobile) ?

                                    <div className="verify-btn" onClick={() => startMobileNumberVerification(mobile)}>VERIFY</div>

                                    : (mobile && !isMobileVerified && startVerify) ?

                                        <div className="otp-container">



                                            <div className="otp-container-row">


                                                <Form.Item

                                                    name="patientNumberOTP"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: "*OTP can't be empty",
                                                        }

                                                    ]}

                                                >
                                                    <Input
                                                        controls={false}
                                                        onKeyDown={allowOnlyNumericsOrDigits}
                                                        style={{ width: "100%" }}
                                                        className='input'
                                                        value={mobileOtp}
                                                        onChange={e => setMobileOtp(e.target.value)}
                                                        placeholder='Enter OTP'
                                                        maxLength={5}
                                                    />
                                                </Form.Item>
                                                <button type='button' className='verify-otp-btn' onClick={() => { verifyMobileNumber(mobile) }}>
                                                    {/* <img src={arrowRigisMobileht} alt="" /> */}
                                                    VERIFY OTP
                                                </button>
                                            </div>

                                        </div>

                                        : (mobile && isMobileVerified == "Failed") ?

                                            <div className="couponerror">
                                                <SimpleCloseIconRed />
                                                &nbsp;{"Invalid OTP"}
                                            </div>

                                            : (mobile && isMobileVerified) ?

                                                <div className="couponsuccess">
                                                    <img src={checkImage} alt="" />
                                                    {"Successfully Verified"}
                                                </div> : ""


                            }

                        </div>


                    </div>


                </div>

                <div className="details-item mandatory">

                    <div className="caption">Patient Name <div className="red">*</div></div>
                    <div className="input-item ">
                        <Form.Item
                            name="patientName"
                            initialValue={patientName}
                            rules={[
                                {
                                    required: true,
                                    message: "*Patient name can't be empty",
                                },
                                {
                                    pattern: new RegExp("^[a-zA-Z_ ]+$"),
                                    message: "Enter only Alphabets"
                                }
                            ]}
                        >
                            <Input
                                onKeyDown={validateLettersOnly}
                                onChange={(e) => { handleChangeFormItem({ key: "patientName", value: e.target.value }) }}
                                style={{ width: "100%" }} className='input' placeholder="Enter Patient Name" />
                        </Form.Item>
                    </div>


                </div>



                <div className="details-item mandatory">

                    <div className="caption">Gender<div className="red">*</div></div>
                    <div className="input-item"></div>
                    <Form.Item
                        name="gender"
                        initialValue={gender}
                        rules={[
                            {
                                required: true,
                                message: "*Choose the gender",
                            }
                        ]}
                    >

                        <Radio.Group name={gender} value={gender} onChange={(e) => { handleChangeFormItem({ key: "gender", value: e.target.value }) }}>

                            <Radio value={"Male"}>Male</Radio>

                            <Radio value={"Female"}>Female</Radio>

                            <Radio value={"Other"}>Other</Radio>

                        </Radio.Group>
                    </Form.Item>
                </div>

                <div className="details-item">

                    <div className="caption">Email Id</div>
                    <div className="input-item">

                        <Form.Item
                            name="emailID"
                            initialValue={emailID}
                            rules={[
                                {
                                    type: "email",
                                    message: "Email id has invalid inputs!",
                                },
                                // {
                                //     pattern: new RegExp("/^[a-zA-Z0-9]+@+[a-zA-Z0-9]+.+[A-z]/"),
                                //     message: "Invalid characters in E-Mail ID"
                                // }                              
                            ]}
                        >
                            <Input
                                placeholder='Enter Email Id'
                                onChange={(e) => { handleChangeFormItem({ key: "emailID", value: e.target.value }) }}
                                style={{ width: "100%" }}
                                // onKeyDown={validateEmailId}
                                maxLength={30}
                                className='input'
                            />

                        </Form.Item>


                    </div>


                </div>

                <div className="details-item">

                    <div className="caption">Hospital Id</div>
                    <div className="input-item">

                        <Form.Item
                            name="patientHospitalId"
                            initialValue={patientHospitalId}
                            rules={[
                                {
                                    required: false,
                                    message: 'Please input your hospital id!',
                                },
                                {
                                    pattern: new RegExp("^[a-zA-Z0-9_ ]+$"),
                                    message: "Enter only letters and numbers"
                                }
                            ]}
                        >
                            <Input
                                placeholder='Enter Hospital Id'
                                onChange={(e) => { handleChangeFormItem({ key: "patientHospitalId", value: e.target.value }) }}
                                style={{ width: "100%" }}
                                maxLength={10}
                                className='input'
                            />

                        </Form.Item>


                    </div>


                </div>

                <div className="details-item mandatory">

                    <div className="caption">Aadhar Number
                    </div>
                    <div className="input-item ">
                        <Form.Item

                            name="aadhaarNumber"
                            initialValue={aadhaarNumber}
                            rules={[
                                {
                                    required: false,
                                    message: "*Aadhaar number can't be empty",
                                },
                                { min: 12, message: 'Enter a valid Aadhaar number' },
                                { max: 12, message: 'Enter a valid Aadhaar number' },
                            ]}
                        >
                            <Input
                                controls={false}
                                onKeyDown={allowOnlyNumericsOrDigits}
                                maxLength={12}
                                value={aadharNumber}
                                onChange={handleAadhaarOnChange}
                                style={{ width: "100%" }} className='input' placeholder="Enter Aadhar Number (12 digits)" />
                            {/* <input  className='input' type="text" name="" id="" /> */}
                        </Form.Item>
                    </div>
                </div>





                <div className="details-item mandatory">

                    <div className="caption">Emergency Contact Name</div>
                    <div className="input-item ">
                        <Form.Item

                            name="emergencyContactName"
                            initialValue={emergencyContactName}
                            rules={[
                                {
                                    required: false,
                                    message: "Emergency contact name can't be empty",
                                },
                                {
                                    pattern: new RegExp("^[a-zA-Z_ ]+$"),
                                    message: "Enter only Alphabets"
                                }
                            ]}
                        >
                            <Input
                                onKeyDown={validateLettersOnly}
                                onChange={(e) => { handleChangeFormItem({ key: "emergencyContactName", value: e.target.value }) }}
                                style={{ width: "100%" }}
                                className='input'
                                placeholder="Enter Emergency Contact Name"
                                value={emergencyContactName} />
                            {/* <input className='input' style={{ width: "100%" }} type="text" name="" id="emergencyContactName" value={emergencyContactName} */}
                            {/* /> */}
                        </Form.Item>


                    </div>


                </div>

                <div className="details-item mandatory contact-number">

                    <div className="caption">Emergency Mobile Number</div>
                    <div className="input-item ">

                        <Form.Item

                            name="emergencyContactNumber"
                            initialValue={emergencyContactNumber?.number}
                            rules={[
                                {
                                    required: false,
                                    message: "Emergency contact number can't be empty",
                                },
                                { min: 6, message: 'The mobile number should be minimum 6 digits', },
                                { max: 12, message: 'The mobile number should be maximum 12 digits' },
                            ]}
                        >

                            <CustomPhoneInputV2
                                defaultCountryCode={emergencyContactNumber?.countryCode}
                                key={emergencyContactNumber?.number}
                                defaultvalue={emergencyContactNumber?.number}
                                name="emergencyContactNumber"
                                onChange={(number, value, data, event, formattedValue) => {


                                    setEmergencyContactNumber(
                                        {
                                            dialCOde: data.dialCode,
                                            number,
                                            countryCode: data.countryCode,
                                            numberWithCode: value

                                        })

                                }}
                                placeholder={"Enter Mobile Number"}
                            />

                            {/* <input className='input' type="text" name="" id="" /> */}
                        </Form.Item>

                    </div>


                </div>


                <button disabled={!isreadyToSubmit()} type="submit" className='submt-btn'>


                    {
                        isSaving ?

                            <div className="payment_loader">
                                Saving &nbsp;
                                <div className="loader-container">
                                    <PulseLoader
                                        Style={{ width: 50 }} color="#fff" loading={true} size={10} />
                                </div>
                            </div>

                            :
                            "SAVE & PROCEED"
                    }

                </button>



            </Form>

        </div>
    )
}

export default PatientDetail
